import { Button, Stack, styled, Typography } from '@mui/material';
import { HeaderClient } from '../../elements/HeaderClient';
import React from 'react';
import { useInjection } from './hook';
import { TableInfiniteScroll } from 'app/components/elements/TableInfiniteScroll';
import { TextEllipsis } from '../../../../../components/elements/TextEllipsis';
import { getfloordata } from 'types/floorplan';

export const ViewFloorPlan = () => {
  const {
    onSortHeader,
    searchParams,
    handleBack,
    paths,
    onClickAction,
    clientId,
    clientName,
    header,
    displayTitle,
    floorplandata
    // listButton,
  } = useInjection();
  const renderDataMap = (floorplandata: getfloordata[] = []) => {
    return floorplandata.map((location) => {
      return {
        name: {
          value: (
            <TextEllipsis
              onClick={() => {
                onClickAction({
                  href: `/pdfmapping/uploadplan/${clientName}/${clientId}/location/${location.locationId}`,
                  locationId: location.locationId
                });
              }}
              text={`${location.name}`}
              styles={{ textDecoration: 'underline', cursor: 'pointer', color: '#226AAA' }}
              width={'80%'}
            />
          )
        },
        actions: {
          value: (
            <Stack flexDirection={'row'} gap={1}>
              <Button
                onClick={() => {
                  onClickAction({
                    href: `/pdfmapping/uploadplan/${clientName}/${clientId}/location/${location.locationId}/update`,
                    locationId: location.locationId
                  });
                }}>
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  Update Floor Plan
                </Typography>
              </Button>
            </Stack>
          )
        }
      };
    });
  };
  return (
    <WrapperCreatePage>
      <HeaderClient
        // onShowLastRoom={pathLastRoom ? handleNavigateLastRoom : undefined}
        // buttons={listButton}
        title={displayTitle}
        // valueFilterType={searchParams.get('type') || ''}
        searchholder="Search"
        // onFilterType={filterByTypeAccess}
        // onFilterClient={() => {}}
        // optionFilterClient={optionTypeAccess}
        // optionFilterType={optionTypeAccess}
        textButton={'Back'}
        onClickButton={handleBack}
        paths={paths}
      />
      <Stack id={'id-table-clients'} sx={{ height: 'calc(100% - 230px)', overflow: 'scroll' }}>
        <TableInfiniteScroll
          sort={{
            field: searchParams.get('sortBy') || '',
            order: searchParams.get('order') || ''
          }}
          onSortHeader={onSortHeader}
          idElementScroll={'id-table-clients'}
          data={renderDataMap(floorplandata)}
          handleFetchMore={() => {}}
          headers={header}
          hasMore={false}
          handleChooseRow={() => {}}
          styledTableRow={{ cursor: ' default ' }}
        />
      </Stack>
    </WrapperCreatePage>
  );
};

const WrapperCreatePage = styled(Stack)(() => ({
  padding: '40px 30px 30px 40px',
  width: '100%',
  height: '100vh',
  gap: '20px'
}));
